/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'persona': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M29 30.208c-.644-.366-4.843-2.851-7-3.724v-3.777c.624-.456 1-1.158 1-2.223V17.5c0-2.475-1.5-4.5-4.5-4.5S14 15.025 14 17.5v2.984c0 1.075.376 1.779 1 2.233v3.767c-2.032.873-6.356 3.357-7 3.724-.801.455-1 .888-1 1.94V34.5c0 .275.225.5.5.5h22c.275 0 .5-.225.5-.5v-2.352c0-1.052-.199-1.485-1-1.94zm8.982 1.864C37.344 31.709 35 30.589 33 29.721v-1.987c2-.124 3.336-1.128 3.912-1.754.576-.625-.482-1.225-1.334-2.218-.851-.994-.983-1.839-.983-3.826 0-1.856-1.516-3.905-3.945-3.935-2.43.03-3.954 2.079-3.954 3.935 0 1.987-.159 2.832-1.01 3.826-.852.993-2.011 1.593-1.435 2.218.179.194.424.426.725.655.469.248.941.504 1.407.763.467.169.997.298 1.616.336v.35c.476.272.921.528 1.306.747C30.718 29.633 31 30.44 31 31.718V35h7.541c.274 0 .459-.229.459-.504v-.993c0-.683-.429-1.098-1.018-1.431z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/persona.js